import "../scss/App.scss"
import Footer from "./Footer"
import Game from "./Game"
import Header from "./Header"

const App = () => {
  return (
    <>
      <Header />
      <Game />
      <Footer />
    </>
  )
}

export default App
